/* eslint-disable @typescript-eslint/no-explicit-any */
import environment from "@environment";
import StringDictionary from "@lib-shared/types/string-dictionary";
import replaceSpaces from "./replace-spaces";
import { Channel, ChannelData } from "core/types";
import context from "core/tv-guide.context";

/**
 * Global data object, grouped by event name with dynamic data pack:
 * - Item-Action-Actor
 * - "Popup-Open-User"
 *
 * - You can add whatever is requested to an array.
 *
 */

const getDataLayer = () => (window as any).dataLayer;

export const dataLayerPush = (eventName: string, dataPacket: any) => {
  dataLayerPushObject({
    event: eventName,
    data: dataPacket,
  });
}

export const dataLayerPushObject = (dataObject: any) => {
  const dataLayer = getDataLayer();

  dataLayer?.push(dataObject);
}

export type AnalyticsMetaData = {
  component_name: string;
  component_type: string;
  cta_text?: string;
  show_name?: string;
  channel_name?: string;
  channel_number?: string;
  target_page_url?: string;
  genre_type?: string;
  package_name?: string;
  nav_text?: string;
  nav_item?: string;
  nav_location?: string;
  show_runtime?: string;
  action_type?: string;
  days_selected?: number;
  view_selected?: string;
  channels_selected?: string;
}

export const getAnalyticTags = (meta: AnalyticsMetaData) => {
  if (environment.menu.disableAnalytics) {
    return {};
  }

  if (!meta.component_name) {
    console.warn("Analytics - component name is missing: ", meta);
    return {};
  }

  meta.target_page_url = meta.target_page_url ?? "_self";

  if (meta.action_type) {
    meta.action_type = replaceSpaces(meta.action_type);
  }

  if (meta.show_name) {
    meta.show_name = replaceSpaces(meta.show_name);
  }

  const properties = Object.keys(meta);

  const dict: StringDictionary = {};

  properties.forEach(key => {
    const metaKey = key as keyof typeof meta;
    const value = meta[metaKey];

    if (!value) {
      return;
    }

    dict[key] = (value ?? "").toString().toLowerCase();
  });

  dict.current_page_url = window.location.href;

  const info = JSON.stringify(dict);

  return {
    "data-component-name": dict.component_name,
    "data-component-info": info
  };
}

export const getChannelTag = (channel: Channel | ChannelData) => {
  return context.useChannelTag
    ? { "data-cdp-channel-tag": channel.tag }
    : { "data-cdp-channel-number": channel.number };
}